export default {
  GIFT_CARD: 'GIFT_CARD',
  CASH: 'CASH',
};
